import React, { ReactNode } from "react"
import { ModalPanel, Title, Button } from "dash-styled"

interface ConfirmProps {
    title: string
    description?: ReactNode
    yesLabel?: string
    noLabel?: string
    onClose: () => void
    onClickYes?: () => void
    onClickNo?: () => void
    extraValue?: ReactNode
    yesFirst?: boolean
    isProcessing?: boolean
}

export const Confirm = ({
    title,
    description,
    yesLabel,
    noLabel,
    onClickYes,
    onClickNo,
    onClose,
    extraValue,
    isProcessing = false
}: ConfirmProps) => {
    return (
        <ModalPanel
            testId="confirm-dialog"
            onClose={onClose}
            className="max-w-2xl w-full"
        >
            <Title component="h2" variant="heading2" weight="semibold">
                {title}
            </Title>
            {description}
            <div className="flex justify-center pt-4">
                {onClickNo && (
                    <Button
                        key="no"
                        color="plain"
                        onClick={onClickNo}
                        testId="confirm-no"
                        className="w-48 mr-4"
                    >
                        {noLabel === undefined ? "Back" : noLabel}
                    </Button>
                )}
                <Button
                    key="yes"
                    onClick={onClickYes}
                    testId="confirm-yes"
                    className={onClickNo === undefined ? "w-auto" : "w-48"}
                    disabled={isProcessing || onClickYes === undefined}
                >
                    {yesLabel === undefined ? "Yes" : yesLabel}
                </Button>
            </div>
            {extraValue}
        </ModalPanel>
    )
}
